import { t } from '@lingui/core/macro';

import type {
  KPINotificationType,
  PageMetaNotificationNameType,
} from '@/api/settings/settingsType';

type PaidSearchKPINameType =
  | 'paidsearch-adgroups-total-visits'
  | 'paidsearch-adgroups-audience-visits'
  | 'paidsearch-adgroups-engaged-companies'
  | 'paidsearch-adgroups-pipeline-influenced'
  | 'paidsearch-adgroups-closed-won-influenced';

export const paidSearchGoalKPIs = (): Partial<
  Record<PageMetaNotificationNameType, KPINotificationType<PaidSearchKPINameType>[]>
> => ({
  'paidsearch-adgroups': [
    { value: 'paidsearch-adgroups-total-visits', label: t`Total Visits`, allowsAudience: false },
    {
      value: 'paidsearch-adgroups-audience-visits',
      label: t`Audience Visits`,
      allowsAudience: true,
    },
    {
      value: 'paidsearch-adgroups-engaged-companies',
      label: t`Audience Engaged Companies`,
      allowsAudience: true,
    },
    {
      value: 'paidsearch-adgroups-pipeline-influenced',
      label: t`Audience ROMS Pipeline Influence`,
      allowsAudience: true,
    },
    {
      value: 'paidsearch-adgroups-closed-won-influenced',
      label: t`Audience Closed Won Influence`,
      allowsAudience: true,
    },
  ],
});
